import { render, staticRenderFns } from "./latestPublicationsFilter.vue?vue&type=template&id=0c9496d6"
import script from "./latestPublicationsFilter.vue?vue&type=script&lang=js"
export * from "./latestPublicationsFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports